export const ZENDESK_LINKS = {
  msAudienceExclusion:
    'https://cheqessentials.zendesk.com/hc/en-us/articles/13134147247761-Microsoft-Ads-Audience-Exclusion',
  msCreateAudienceExclusion:
    'https://cheqessentials.zendesk.com/hc/en-us/articles/13292953074193-Creating-an-Audience-For-Exclusion-on-Microsoft-Ads',
  msWhereToFindDomainTrackingParameters:
    'https://cheqessentials.zendesk.com/hc/en-us/articles/12992163693329-Where-to-Find-my-Domain-s-Tracking-Parameters',
  googleAdsAudienceExclusion:
    'https://cheqessentials.zendesk.com/hc/en-us/articles/13134145467793-Google-Ads-Audience-Exclusion',
  creatingAudienceForExclusionGoogleAds:
    'https://cheqessentials.zendesk.com/hc/en-us/sections/14089728175633-Audience-Exclusion',
  pixelGuardOverview: 'https://cheqessentials.zendesk.com/hc/en-us/articles/13049768202897',
}
